<div class="header">
    <h4
        *ngIf="title"
        mat-dialog-title
    >{{title}}</h4>
    <button
        class="close-button"
        mat-icon-button
        mat-dialog-close
    >
        <mat-icon>close</mat-icon>
    </button>
</div>
<div mat-dialog-content>
    <div class="container">
        <ng-container #target></ng-container>
        <ng-template #loader>
            <app-loader />
        </ng-template>
    </div>
</div>

<div mat-dialog-actions class="action-buttons">
    <button
        mat-flat-button
        color="simple"
        [disabled]="pending"
        (click)="onCancel()"
    >
        {{ cancelLabel }}
    </button>
    <button
        mat-flat-button
        color="primary"
        [pending]="pending"
        (click)="onSubmit()"
    >
        <mat-icon>{{ submitIcon }}</mat-icon>
        {{ submitLabel }}
    </button>
</div>
